import { useState } from 'react';
import './App.css';
import RepoTable from './components/RepoTable';
import SearchBar from './components/SearchBar';
import UserCard from './components/UserCard';
import { getUserData, getUserRepos } from './services/githubApi';

function App() {
  const [user, setUser] = useState(null);
  const [repos, setRepos] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (username) => {
    setLoading(true);
    setError(null);
    setUser(null);
    setRepos([]);

    try {
      const userData = await getUserData(username);
      const reposData = await getUserRepos(username);
      setUser(userData);
      setRepos(reposData);
    } catch (err) {
      setError('User not found or API error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <h1>GitHub User Search </h1>
      <SearchBar onSearch={handleSearch} />
      {loading && <p>Loading...</p>}
      {error && <p>{error}</p>}
      <UserCard user={user} />
      <RepoTable repos={repos} />
    </div>
  );
}

export default App;